import { css } from '@emotion/react';

/**
 * Resets default browser styles in our app.
 *
 * Took parts of different style resets to achieve consistency in visual look
 * and feel across different platforms, and give us full control over styling
 * our own elements logically.
 *
 * Significant opinions:
 * - 0 margin and padding on everything. We define our own spacing
 * - border-box sizing by default
 */
export const styleReset = css`
  * {
    margin: 0;
    padding: 0;
  }
  /*
   * Stolen from modern-normalize
   * https://github.com/sindresorhus/modern-normalize/blob/master/modern-normalize.css
   */
  /* Use a better box model (opinionated). */
  html {
    box-sizing: border-box;
  }
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  /**
  * Use a more readable tab size (opinionated).
  */
  :root {
    -moz-tab-size: 4;
    tab-size: 4;
  }
  /**
  * 1. Correct the line height in all browsers.
  * 2. Prevent adjustments of font size after orientation changes in iOS.
  */
  html {
    line-height: 1.15; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
  }
  /* Text-level semantics
    ========================================================================== */
  /**
  * Add the correct text decoration in Chrome, Edge, and Safari.
  */
  abbr[title] {
    text-decoration: underline dotted;
  }
  /**
  * Prevent 'sub' and 'sup' elements from affecting the line height in all browsers.
  */
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  /* Forms
    ========================================================================== */
  /**
  * Change the font styles in all browsers.
  */
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
  }
  /**
  * Remove the inheritance of text transform in Edge and Firefox.
  * 1. Remove the inheritance of text transform in Firefox.
  */
  button,
  select {
    /* 1 */
    text-transform: none;
  }
  /**
  * Correct the inability to style clickable types in iOS and Safari.
  */
  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }
  /**
  * Remove the inner border in Firefox.
  */
  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
  }
  /**
  * Restore the focus styles unset by the previous rule.
  */
  button:-moz-focusring,
  [type='button']:-moz-focusring,
  [type='reset']:-moz-focusring,
  [type='submit']:-moz-focusring {
    outline: 1px dotted ButtonText;
  }
  /**
  * Add the correct vertical alignment in Chrome and Firefox.
  */
  progress {
    vertical-align: baseline;
  }
  /**
  * Correct the cursor style of increment and decrement buttons in Safari.
  */
  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }
  /**
  * 1. Correct the odd appearance in Chrome and Safari.
  * 2. Correct the outline style in Safari.
  * 3. Do not display the extra buttons in WebKit or IE.
  */
  [type='search'] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }
  [type='search']::-webkit-search-decoration,
  [type='search']::-webkit-search-cancel-button,
  [type='search']::-webkit-search-results-button,
  [type='search']::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }
  [type='search']::-ms-clear,
  [type='search']::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }
  /**
  * 1. Correct the inability to style clickable types in iOS and Safari.
  * 2. Change font properties to 'inherit' in Safari.
  */
  ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }
  /* Interactive
    ========================================================================== */
  /*
  * Add the correct display in Chrome and Safari.
  */
  summary {
    display: list-item;
  }
  /* END modern-normalize */
  /* Stolen from Meyer CSS Reset */
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  /* End Meyer CSS reset */
`;
